import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useSettings, resolveImageUrl } from "../../lib/SettingsContext";

const POINTS = [
  "10+ years crafting print communication for businesses across India",
  "In-house design support — from concept to colour-accurate proofs",
  "Modern offset, digital, vinyl, flex & finishing under one roof",
  "Strict QC and on-time delivery, every single project",
];

export default function About() {
  const { settings } = useSettings();
  const img1 = resolveImageUrl(settings?.about_image_1_url) || "https://images.unsplash.com/photo-1707263899445-601d5c695598?crop=entropy&cs=srgb&fm=jpg&q=85&w=700";
  const img2 = resolveImageUrl(settings?.about_image_2_url) || "https://images.pexels.com/photos/5706020/pexels-photo-5706020.jpeg?auto=compress&cs=tinysrgb&w=700";
  const img3 = resolveImageUrl(settings?.about_image_3_url) || "https://images.unsplash.com/photo-1624567881801-a5a85867d990?crop=entropy&cs=srgb&fm=jpg&q=85&w=700";
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container-x grid lg:grid-cols-12 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-6 relative"
        >
          <div className="grid grid-cols-2 gap-4">
            <img
              src={img1}
              alt="Printing facility"
              className="rounded-3xl object-cover h-64 w-full border border-gray-200"
            />
            <img
              src={img2}
              alt="Printed brochures"
              className="rounded-3xl object-cover h-64 w-full border border-gray-200 mt-10"
            />
            <img
              src={img3}
              alt="Business cards"
              className="rounded-3xl object-cover h-64 w-full border border-gray-200 -mt-6"
            />
            <div className="rounded-3xl bg-brand-blue text-white p-6 flex flex-col justify-end">
              <div className="font-display text-5xl font-extrabold leading-none">10+</div>
              <div className="overline mt-2 text-brand-green">Years of Craft</div>
              <p className="mt-3 text-sm text-white/80">Trusted by 1,200+ businesses across Madhya Pradesh.</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-6"
        >
          <div className="overline text-brand-green">About PPrints</div>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold text-brand-ink leading-tight tracking-tight">
            Where craftsmanship meets <span className="text-brand-blue">commercial precision.</span>
          </h2>
          <p className="mt-5 text-gray-600 leading-relaxed">
            PPrints is a full-service print studio based in Bhopal, blending traditional craft with modern technology to produce work that elevates how brands look, feel and communicate. From a single business card to a citywide branding rollout, we deliver with the same obsession for detail.
          </p>

          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex gap-3 text-gray-700">
                <CheckCircle2 className="h-5 w-5 text-brand-green shrink-0 mt-0.5" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
